// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2EH6_","label":"styles_label__2c48W"};